export default __webpack_public_path__ + "static/media/pdf_feriti.ae37e6fe.png";